import { Component } from 'react';
import { RouteComponentProps } from 'react-router';
import { SimpleCard } from 'src/components/simple-card';
import { withTranslation, WithTranslation } from 'react-i18next';
import RegisterParticipant from 'src/components/register-participant/index';
import Modal from '../../components/modal/modal';
import ZoomableIframe from 'src/components/iframe';

type RegisterParticipantPageProps = RouteComponentProps<any> & WithTranslation;
const Config = window.VBwidgetConfig;

interface RegisterCallSourcePageState {
    viewer: JSX.Element
}

class RegisterParticipantPage extends Component<RegisterParticipantPageProps, RegisterCallSourcePageState, any> {
    constructor(props: RegisterParticipantPageProps) {
        super(props);
        this.setLanguage(props.location.search);
        const callHash = this.props.match.params.callHash;
        window.callHash = callHash;
        this.state = {
            viewer: null
        };
    }

    private setLanguage = (search: string) => {
        const query = new URLSearchParams(search);
        const lang = query.get('lang');
        if (lang) {
            this.props.i18n.changeLanguage(lang);
        }
    }

    openFileViewer = (url: string) => {
        const viewerUrl = Config.docViewer.replace('{{url}}', url);
        const { t } = this.props;
        this.setState({
            viewer: (
                <Modal
                    header={t('appointment:modalHeader')}
                    onReject={() => {
                        this.setState({ viewer: null });
                    }}
                    content={
                        <ZoomableIframe title={t('appointment:modalHeader')} viewerUrl={viewerUrl} />
                    }
                    width="100%"
                    height="100%"
                />
            )
        });
    }

    public async componentDidUpdate(prevProps: RegisterParticipantPageProps) {
        const search = this.props.location.search;
        const prevSearch = prevProps.location.search;
        if (search !== prevSearch) {
            this.setLanguage(search);
        }
    }

    public openConference = (url: string) => {
        const lang = this.props.i18n.language;
        window.location.href = `${url}?lang=${lang}&agreementChecked=true`;
    }

    render() {
        const callHash = this.props.match.params.callHash;
        const { t } = this.props;
        const {
            viewer
        } = this.state;
        if (!callHash) {
            return <SimpleCard title={t('title')}>{t('CallHashNotFound')}</SimpleCard>;
        }

        return <>
            <RegisterParticipant
                callHash={callHash}
                onSuccess={this.openConference}
                openFileViewer={this.openFileViewer} />

            {viewer}
        </>;
    }
}

export default withTranslation('register-participant')(RegisterParticipantPage);
